<template>
  <div id="date-picker">
    <v-row>
      <v-col cols="12" md="8" class="mb-0 pb-0">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          content-class="elevation-1"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formatedDateTime"
              :label="label"
              v-bind="attrs"
              :disabled="loading"
              autocomplete="off"
              :hint="dateFormatHint"
              persistent-hint
              v-on="on"
              @keydown.tab="dateMenu = false"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="myDate.date"
            no-title
            first-day-of-week="1"
            :class="datePickerClass"
            @input="dateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="4" class="mb-0 pb-0">
        <div class="date-picker-time items-flex">
          <v-menu
            ref="timePickerMenu"
            v-model="timeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="myDate.time"
            transition="scale-transition"
            offset-y
            min-width="290px"
            content-class="elevation-1"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="myDate.time"
                :label="labelTime"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                :disabled="loading"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="timeMenu"
              v-model="myDate.time"
              full-width
              format="24hr"
              :class="datePickerClass"
              @click:minute="$refs.timePickerMenu.save(myDate.time)"
            ></v-time-picker>
          </v-menu>
          <InfoIcon :size="17" :text="infoTime || $t('views.core.datePicker.infoTime')" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import InfoIcon from '@/views/components/common/InfoIcon'

export default {
  components: { InfoIcon },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelTime: {
      type: String,
      default: '',
    },
    infoTime: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    datePickerClass: {
      type: String,
      default: '',
    },
    hourDefault: {
      type: Number,
      default: 12,
    },
  },
  data: () => ({
    dateMenu: false,
    timeMenu: false,
    myDate: {},
    minute: 60 * 1000,
    hour: 60 * 60 * 1000,
    valueCopy: null,
    formatedDateTime: null,
    dateFormat: 'dd/MM/yyyy',
    dateFormatHint: 'DD/MM/YYYY',
    timeFormatHint: 'hh:mm',
  }),
  computed: {
    dateTime() {
      const time = DateTime.fromISO(this.myDate.time)
      const isoTime = time.hour * this.hour + time.minute * this.minute
      return DateTime.fromISO(this.myDate.date).plus(isoTime)
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value === this.valueCopy) return
        const value = DateTime.fromISO(this.value)
        const isoDate =
          value && !value.invalid
            ? value
            : DateTime.now().set({ hour: this.hourDefault, minute: 0, second: 0 })
        this.myDate = {
          date: isoDate.toISODate(),
          time: this.getHour(isoDate.hour, isoDate.minute),
        }
        this.$set(this, 'formatedDateTime', this.dateTime.toFormat(this.dateFormat))
      },
      immediate: true,
    },
    formatedDateTime: {
      handler() {
        if (this.isValidUserFormatDate(this.formatedDateTime)) {
          this.$set(this.myDate, 'date', this.userToDefaultFormat(this.formatedDateTime))
        }
      },
      immediate: true,
    },
    dateTime: {
      handler() {
        this.$set(this, 'formatedDateTime', this.dateTime.toFormat(this.dateFormat))
        this.valueCopy = this.dateTime.toISO()
        this.$emit('input', this.dateTime.toISO())
      },
      immediate: true,
    },
  },
  methods: {
    userToDefaultFormat(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    isValidUserFormatDate(date) {
      if (!date) return false
      const dateSplitted = date.split('/')
      if (dateSplitted.length !== 3) return false
      if (dateSplitted[2].length !== 4) return false
      return DateTime.fromFormat(date, this.dateFormat).isValid
    },
    getHour(hour, minute) {
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      return hour + ':' + minute
    },
  },
}
</script>

<style lang="scss">
.date-picker-time {
  &.items-flex {
    display: flex;
    align-items: center;
  }
}
</style>
